var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"delivered-button",attrs:{"title":"Mark As Delivered"}},[_c('img',{staticClass:"truck-icon",attrs:{"src":require("./delivered.png"),"alt":"","width":"25px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }